import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _get from 'lodash/get';

import COLORS from '@mlb/react-patterns/style/universal.color';

const PAd = styled.div`
    display: block;
    margin: 0 auto;
    line-height: 0;
    text-align: center;

    &.ad-responsive-slot, &.ad-outofpage {
        display: inline;
    }
`;

const ResponsiveAd = styled.div`
    margin-left: auto;
    margin-right: auto;
    background-color: ${COLORS.transparent} !important;
    transform: translate(0);

    &[data-sizes='[[1,1]]'],
    &[data-sizes='[[215,40]]'],
    &[data-sizes='[[300,250]]'],
    &[data-sizes='[[320,50]]'],
    &[data-sizes='[[375,100]]'],
    &[data-sizes='[[768,199]]'],
    &[data-sizes='[[1280,250]]']
    {
        height: auto !important;
    }

    div:empty {
        height: 0px !important;
    }
`;

const Ad = ({
    adSlots,
    adUnit,
    targeting,
    pageTargeting,
    isOutOfPage,
    isResponsive,
    syncWithVideoAd,
}) => {
    
    const mappedAdSlots = adSlots && adSlots.map((adSlot) => {

        const adSlotContentId = _get(adSlot, 'contentId');
        const adSlotContainerId = adSlotContentId && `ad-${adSlotContentId}`;
        const adSlotBreakpoints = _get(adSlot, 'breakpoints');
        const adSlotDataSizes = !isOutOfPage ? _get(adSlot, 'sizes') : null;

        return (
            <ResponsiveAd
                className={'ad-responsive-size'}
                id={adSlotContainerId}
                key={adSlotContainerId}
                data-syncwithvideoad={syncWithVideoAd}
                data-thresholds={adSlotBreakpoints && JSON.stringify(adSlotBreakpoints)}
                data-sizes={adSlotDataSizes && JSON.stringify(adSlotDataSizes)}
            />
        );

    });

    return (
        <PAd
            className={`p-ad${isResponsive ? ' ad-responsive-slot' : ''}${isOutOfPage ? ' ad-outofpage' : ''}`}
            data-adunit={adUnit}
            data-targeting={targeting && JSON.stringify(targeting)}
            data-page-targeting={pageTargeting && JSON.stringify(pageTargeting)}
        >
            {mappedAdSlots}
        </PAd>
    );

};

Ad.propTypes = {
    adSlots: PropTypes.arrayOf(
        PropTypes.shape({
            contentId: PropTypes.string,
            sizes: PropTypes.arrayOf(PropTypes.array),
            breakpoints: PropTypes.array,
        })
    ),
    pageTargeting: PropTypes.shape(),
    targeting: PropTypes.shape(),
    adUnit: PropTypes.string,
    isOutOfPage: PropTypes.bool,
    isResponsive: PropTypes.bool,
    syncWithVideoAd: PropTypes.bool,
};

Ad.defaultProps = {
    pageTargeting: null,
    targeting: null,
    adUnit: null,
    isOutOfPage: false,
};

export const shouldNotReRender = (prevProps, newProps) => {

    return JSON.stringify(prevProps.pageTargeting) === JSON.stringify(newProps.pageTargeting);

};

export default memo(Ad, shouldNotReRender);
